module.exports = __webpack_public_path__ + "img/product-shot_05_loading.61895c94.jpg";